import { render, staticRenderFns } from "./newAktiven.vue?vue&type=template&id=5b8ce2a5&scoped=true&"
import script from "./newAktiven.vue?vue&type=script&lang=js&"
export * from "./newAktiven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8ce2a5",
  null
  
)

export default component.exports